<template>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ _('Notification') }}</h4>
    </div>
    <div class="modal-body">
      <p v-if="editing" class="text-danger">{{ _('Editing recipient does not update to the customer register') }}</p>
      <table class="table">
        <tbody>
          <tr>
            <th>ID</th>
            <td>{{ notification.id }}</td>
          </tr>
          <tr>
            <th>{{ _('Order') }}</th>
            <td>{{ notification.orderid }}</td>
          </tr>
          <tr>
            <th>{{ _('Send time') }}</th>
            <td>{{ DateTime.fromSeconds(Number(notification.ts), { zone: timezone }).toFormat(dateFormat + " '" + _('at') + "' " + timeFormat) }}</td>
          </tr>
          <tr>
            <th>{{ _('Notification') }}</th>
            <td>{{ notification.notification }}</td>
          </tr>
          <tr>
            <th>{{ _('Recipient') }}</th>
            <td v-if="!editing">{{ recipient }}</td>
          </tr>
          <tr>
            <th>{{ _('Customer') }}</th>
            <td>{{ notification.client }}</td>
          </tr>
          <tr>
            <th>{{ _('Status') }}</th>
            <td v-html="notificationStatus(notification.status)"></td>
          </tr>
          <tr v-if="parseInt(notification.status, 10) !== 0">
            <th></th>
            <td><a class="btn btn-info" v-on:click="resetStatus"><i class="fa fa-refresh resetbutton"></i> {{ _('Resend') }}</a></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="modal-footer">
      <button class="btn btn-default" v-on:click="hideModal"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
      <!-- <button class="btn btn-success" v-on:click="saveNotification"><i class="fa fa-fw fa-save"></i> {{ _('Save') }}</button> -->
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import components from '~/lib/components'
import { DateTime } from 'luxon'

export default {
  data () {
    return {
      editing: false,
      loading: false,
      notification: {},
      DateTime: DateTime
    }
  },
  mixins: [components],
  computed: {
    recipient () {
      if (parseInt(this.notification.type) === 1) {
        if (this.notification.custom_numbers) {
          return this.notification.custom_numbers.split(';').join('<br/>')
        }
        return this.notification.phone
      } else {
        if (this.notification.custom_emails) {
          return this.notification.custom_emails.split(';').join('<br/>')
        }
        return this.notification.email
      }
    }
  },
  methods: {
    hideModal () {
      this.$emit('close')
    },
    async saveNotification () {
      const notification = this.notification
      const id = this.notification.id
      let response
      let data = {
        status: notification.status,
        id: id,
        type: notification.type
      }
      if (notification.type === 1) {
        Object.assign(data, { 'recipient': notification.phone })
      } else {
        Object.assign(data, { 'recipient': notification.email })
      }

      try {
        response = await axios.put(this.baseDomain + this.shopId + '/notificationschedule/' + id.replace(/-/, ':') + '.json?apikey=' + this.apiKey, data)
      } catch (e) {
        this.editing = false
        return
      }
      this.editing = false
    },
    notificationStatus (val) {
      const _ = this._
      switch (parseInt(val, 10)) {
        case 0:
          return _('Not sent')
        case 1:
          return _('Sent')
        case 2:
          return _('Send failed')
        case 3:
          return _('Not paid')
        case 4:
          return _('Skipped')
        case 5:
          return _('SMS service disabled')
        case 6:
          return _('No PIN found')
        case 7:
          return _('No reservation found')
        case 8:
          return _('Not confirmed')
        case 9:
          return _('No checkin/checkout')
        case 10:
          return _('Processing')
      }
    },
    async resetStatus() {
      if (this.notification && this.notification.id) {
        const id = this.notification.id
        let response
        const data = {
          status: 0,
          id: id
        }
        try {
          response = await axios.put(this.baseDomain + this.shopId + '/notificationschedule/' + id.replace(/-/, ':') + '.json?apikey=' + this.apiKey, data)
        } catch(e) {
          return
        }
        this.notification.status = 0
      }
    },
    loadNotification (id) {
      return new Promise(async (resolve, reject) => {
        this.loading = true
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/notifications/' + id + '.json?apikey=' + this.apiKey + this.versionStr)
        } catch (e) {
          this.loading = false
          this.showError(e)
          reject()
          return
        }
        this.notification = response.data
        this.loading = false
        this.storeState()
        resolve(this.notification)
      })
    }
  },
  created () {
    if (this.component && this.component.initData) {
      // this.loadNotification(this.component.initData.notificationId)
      this.notification = this.component.initData.notification
    }
  }
}
</script>